export default "__VITE_ASSET__DphlcHhu__"